export class JoinConsultant {
    public static readonly type = '[Messaging] Join consultant';

    constructor(public id: string, public role: string, public message: string = '') {}
}
